import React from 'react';
import { HomeDataContext } from "../contexts/HomeDataContext";
import { homeDataService } from "../services/HomeDataService";
import HomeDataContextProvider from "../contexts/HomeDataContext";
import "@fontsource/montserrat";

import { useLocation, useHistory, useParams } from 'react-router-dom';

const VideoWithLink = () => {
  const location = useLocation();
  let { id } = useParams()
  const searchParams = new URLSearchParams(location.search);
  const firstUrl = searchParams.get('');
  const text = searchParams.get('');
  const [loading, setLoading] = React.useState(true);

  const [link, setLink] = React.useState("");
  const [text1, setText] = React.useState("");
  const [url, setUrl] = React.useState("");
  const [videoEnded, setVideoEnded] = React.useState(false);
  const { homeDataState, dispatch } = React.useContext(HomeDataContext);
  React.useEffect(() => {
    async function fetchLink() {
      console.log("Fetching with ID:", id); // Debug log to confirm the ID being used
      const url = `${process.env.REACT_APP_URL || "http://localhost:8080/"}api/pnl/tour/d-id/getqrcodeofcode?code=${encodeURIComponent(id)}`;
  
      try {
        const response = await fetch(url);
        if (!response.ok) {  // Check if the response was successful
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        console.log("Data received:", data);  // Log the data to see what's being returned
        setUrl(data.video);
        setLink(data.link)
        setText(data.text)
      } catch (error) {
        console.error("Error fetching data:", error.message);  // Log any errors that occur
      } finally {
        setLoading(false);  // Ensure loading is set to false regardless of the result
      }
    }
  
    fetchLink();
  }, [id, location.search]);  // Dependency array to control re-running of effect



/*React.useEffect(() => {
   /if (firstUrl) {
      setLink(decodeURIComponent(firstUrl));
    }
    if (text) {
      setText(decodeURIComponent(text));
    }
  }, [firstUrl, text]);*/


  //https://hopguides.s3.eu-central-1.amazonaws.com/library/1698218331008-18.mp4
  return (
    <div className="bg-white fixed inset-0 overflow-hidden">

      {loading ? (
        <div className="flex items-center justify-center h-full">
          Loading video...
        </div>
      ) : (
        <>
        <video
          className="w-full h-full object-contain absolute inset-0"
          controls
          onEnded={() => setVideoEnded(true)}
          playsInline // Important for preventing fullscreen on mobile devices
        >
          <source src={"https://hopguides.s3.eu-central-1.amazonaws.com/videos/" + url} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

      {videoEnded && (
        <div className="absolute inset-0 flex flex-col justify-center items-center bg-white p-4">

          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontFamily: 'Montserrat', textDecoration: 'underline' }}
            className="px-6 py-3 text-blue-500 text-m rounded hover:bg-opacity-80 transition duration-300"
          >
            {text1}
          </a>
        </div>
      )}
      </>
    )}
    </div>
  );
}


export default VideoWithLink;